"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _padStart = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/pad-start"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/values"));
var _lodash = _interopRequireDefault(require("lodash"));
var htmlparser = _interopRequireWildcard(require("htmlparser2"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var EmojiProvider = _interopRequireWildcard(require("@/libs/EmojiProvider"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Vue = require('vue');
var _default = exports.default = Vue.component('irc-input', {
  props: ['placeholder'],
  data: function data() {
    return {
      last_known_value: '',
      text_value: '',
      current_el: null,
      current_el_pos: 0,
      default_colour: null,
      default_bgcolour: null,
      // Maps a normalised lowercase hex colour (#rrggbb) to a 2 digit IRC code.
      // Foreground and background share it, as a colour index means the same
      // thing in both positions.
      code_map: Object.create(null),
      // Persistent formatting modes. These survive sending a message and
      // are only cleared by the user toggling them off or pressing reset.
      persistent: {
        bold: false,
        italic: false,
        underline: false,
        strikethrough: false
      }
    };
  },
  computed: {
    editor: function editor() {
      return this.$refs.editor;
    }
  },
  mounted: function mounted() {
    this.resetStyles();
  },
  methods: {
    onTextInput: function onTextInput(event) {
      if (event.data[event.data.length - 1] === '\n') {
        var _context;
        event.preventDefault();
        this.setCurrentWord((0, _trim.default)(_context = event.data).call(_context));
      }
    },
    onPaste: function onPaste(event) {
      var _this = this;
      event.preventDefault();
      if (typeof event.clipboardData !== 'undefined') {
        var ignoreThisPaste = false;
        var clpData = event.clipboardData;
        clpData.types.forEach(function (type) {
          var ignoreTypes = ['Files', 'image'];
          ignoreTypes.forEach(function (ig) {
            if (type.indexOf(ig) > -1) {
              ignoreThisPaste = true;
            }
          });
        });
        if (ignoreThisPaste) {
          return;
        }
        document.execCommand('insertText', false, clpData.getData('text/plain'));
      } else {
        // IE11
        var clpText = window.clipboardData.getData('Text');
        if (!clpText) {
          return;
        }
        var selection = window.getSelection();
        var range = selection.getRangeAt(0);
        if (range) {
          range.deleteContents();
          range.insertNode(document.createTextNode(clpText));
        }
      }
      setTimeout(function () {
        _this.updateValueProps();
      }, 0);
    },
    onDrop: function onDrop(event) {
      var raw = event.dataTransfer.getData('text/html');
      if (!raw) {
        return;
      }
      var html = document.createElement('div');
      html.innerHTML = raw;
      if (html.childNodes.length === 0 || html.childNodes.length > 1) {
        return;
      }
      var node = html.childNodes[0];
      if (node instanceof HTMLImageElement && node.classList.contains('kiwi-messagelist-emoji')) {
        var _context2;
        event.preventDefault();
        var emojis = EmojiProvider.getEmojis((0, _trim.default)(_context2 = node.alt).call(_context2));
        if (!emojis.length) {
          return;
        }
        this.addImg(emojis[0].ascii, emojis[0].url, emojis[0].imgProps);
      }
    },
    onFocus: function onFocus(event) {
      this.focus();
      if (!this.getRawText()) {
        this.reapplyDefaultColours();
      }
      this.$emit('focus', event);
    },
    updateSpacing: function updateSpacing() {
      var editor = this.$refs.editor;
      if (!editor) {
        return;
      }
      editor.childNodes.forEach(function (node) {
        var _context3;
        if (node.nodeName !== 'IMG') {
          return;
        }
        node.alt = (0, _trim.default)(_context3 = node.alt).call(_context3);
        if (node.previousSibling) {
          var _context4;
          var text = node.previousSibling.textContent.replace(/\xA0/g, ' ');
          var isEmpty = text.length === 0;
          var isImg = node.previousSibling.nodeName === 'IMG';
          var isText = (0, _includes.default)(_context4 = ['#text', 'SPAN']).call(_context4, node.previousSibling.nodeName);
          if (isImg || isText && (isEmpty || text[text.length - 1].indexOf(' ') === -1)) {
            node.alt = ' ' + node.alt;
          }
        }
        if (node.nextSibling) {
          var _context5;
          var _text = node.nextSibling.textContent.replace(/\xA0/g, ' ');
          var isNeeded = _text.length !== 0 || !node.nextSibling.nextSibling;
          var _isText = (0, _includes.default)(_context5 = ['#text', 'SPAN']).call(_context5, node.nextSibling.nodeName);
          if (_isText && isNeeded && (_text.length === 0 || _text[0].indexOf(' ') === -1)) {
            node.alt += ' ';
          }
        }
      });
    },
    updateValueProps: function updateValueProps() {
      if (!this.$el.contains(document.activeElement)) {
        return;
      }
      var selection = window.getSelection();
      if (selection.rangeCount === 0) {
        return;
      }
      this.current_el_pos = selection.anchorOffset;
      this.current_el = selection.anchorNode;
      this.maybeEmitInput();
    },
    selectionToEnd: function selectionToEnd() {
      var el = this.$refs.editor.lastChild || this.$refs.editor;
      this.current_el = el;
      if (el.nodeType === 3) {
        this.current_el_pos = el.length;
      } else if (this.$el.contains(document.activeElement)) {
        document.execCommand('selectAll', false, null);
        document.getSelection().collapseToEnd();
        this.updateValueProps();
      } else {
        this.current_el_pos = 0;
      }
    },
    setValue: function setValue(newVal) {
      this.value = newVal;
      this.$refs.editor.innerHTML = newVal;
    },
    getValue: function getValue() {
      return this.$refs.editor.innerHTML;
    },
    maybeEmitInput: function maybeEmitInput() {
      var currentHtml = this.$refs.editor.innerHTML;
      if (this.last_known_value !== currentHtml) {
        this.$emit('input', currentHtml);
        this.last_known_value = currentHtml;
      }
    },
    /**
     * Turn any CSS colour the browser may hand back into a lowercase #rrggbb
     * string. Returns null for anything that isn't a solid colour (including
     * "transparent" and fully transparent rgba()), which means "no colour".
     */
    normaliseColour: function normaliseColour(input) {
      var _context6;
      if (!input) {
        return null;
      }
      var value = (0, _trim.default)(_context6 = String(input)).call(_context6).toLowerCase();
      var m = value.match(/^#([0-9a-f]{3})$/);
      if (m) {
        var _context7;
        return '#' + (0, _map.default)(_context7 = m[1].split('')).call(_context7, function (c) {
          return c + c;
        }).join('');
      }
      m = value.match(/^#([0-9a-f]{6})$/);
      if (m) {
        return '#' + m[1];
      }
      m = value.match(/^rgba?\(\s*(\d+)[\s,]+(\d+)[\s,]+(\d+)(?:[\s,/]+([\d.]+%?))?\s*\)$/);
      if (m) {
        if (m[4] !== undefined && parseFloat(m[4]) === 0) {
          return null;
        }
        var toHex = function toHex(n) {
          var _context8;
          return (0, _slice.default)(_context8 = '0' + Math.min(255, parseInt(n, 10)).toString(16)).call(_context8, -2);
        };
        return '#' + toHex(m[1]) + toHex(m[2]) + toHex(m[3]);
      }
      return null;
    },
    /**
     * CSS colour -> 2 digit IRC code, or null if it isn't one of the IRC colours
     * we have applied (e.g. the theme's default text colour).
     */
    resolveColourCode: function resolveColourCode(value) {
      var hex = this.normaliseColour(value);
      return hex ? this.code_map[hex] || null : null;
    },
    buildIrcText: function buildIrcText() {
      var _this2 = this,
        _context10;
      this.updateSpacing();
      var source = this.$refs.editor.innerHTML;
      var textValue = '';

      // Each open element gets a state object with its *effective* formatting
      // (inherited from its parents plus its own). The root state is "nothing".
      var stack = [{
        bold: false,
        italic: false,
        underline: false,
        strikethrough: false,
        fg: null,
        bg: null
      }];
      var current = function current() {
        return stack[stack.length - 1];
      };
      var hasColour = function hasColour(st) {
        return !!(st.fg || st.bg);
      };
      // \x03FG,BG. A background needs a foreground, 99 means "default colour".
      var colourCode = function colourCode(st) {
        if (!hasColour(st)) {
          return '';
        }
        return '\x03' + (st.fg || '99') + (st.bg ? ',' + st.bg : '');
      };
      var formatCodes = function formatCodes(st) {
        return (st.bold ? '\x02' : '') + (st.italic ? '\x1d' : '') + (st.underline ? '\x1f' : '') + (st.strikethrough ? '\x1e' : '');
      };
      var openCodes = function openCodes(st) {
        return formatCodes(st) + colourCode(st);
      };
      var parser = new htmlparser.Parser({
        onopentag: function onopentag(name, attribs) {
          var _context9;
          var parent = current();
          var st = (0, _assign.default)({}, parent);
          var style = attribs.style || '';

          // Colours. A value that doesn't map to an IRC colour (transparent,
          // the theme default, ...) clears the inherited colour.
          var fgMatch = style.match(/(?:^|;)\s*color:\s*([^;]+)/);
          var bgMatch = style.match(/(?:^|;)\s*background(?:-color)?:\s*([^;]+)/);
          var fgValue = fgMatch ? (0, _trim.default)(_context9 = fgMatch[1]).call(_context9) : attribs.color;
          if (fgValue) {
            st.fg = _this2.resolveColourCode(fgValue);
          }
          if (bgMatch) {
            var _context0;
            st.bg = _this2.resolveColourCode((0, _trim.default)(_context0 = bgMatch[1]).call(_context0));
          }

          // Bold
          if (name === 'b' || name === 'strong' || /font-weight:\s*(bold|[6-9]00)/.test(style)) {
            st.bold = true;
          }
          // Italic
          if (name === 'i' || name === 'em' || /font-style:\s*italic/.test(style)) {
            st.italic = true;
          }
          // Underline
          if (name === 'u' || /text-decoration[^;]*underline/.test(style)) {
            st.underline = true;
          }
          // Strikethrough
          if (name === 's' || name === 'strike' || name === 'del' || /text-decoration[^;]*line-through/.test(style)) {
            st.strikethrough = true;
          }
          stack.push(st);

          // A new line: close everything, break, then re-open the full state
          // so every IRC line carries its own formatting.
          if (name === 'div' || name === 'br') {
            if (openCodes(parent)) {
              textValue += '\x0f';
            }
            textValue += '\n' + openCodes(st);
            return;
          }
          var colourChanged = st.fg !== parent.fg || st.bg !== parent.bg;
          if (colourChanged && !hasColour(st)) {
            // Colour went back to default: \x0f is the only reliable way to
            // drop it, so reset and re-apply the formats.
            textValue += '\x0f' + formatCodes(st);
          } else {
            if (colourChanged) {
              textValue += colourCode(st);
            }
            if (st.bold && !parent.bold) textValue += '\x02';
            if (st.italic && !parent.italic) textValue += '\x1d';
            if (st.underline && !parent.underline) textValue += '\x1f';
            if (st.strikethrough && !parent.strikethrough) textValue += '\x1e';
          }
          if (name === 'img' && attribs.alt) {
            textValue += attribs.alt;
          }
        },
        ontext: function ontext(text) {
          textValue += text;
        },
        onclosetag: function onclosetag() {
          var st = stack.pop();
          var parent = current();
          if (st.fg !== parent.fg || st.bg !== parent.bg) {
            // Reset (\x0f) rather than a bare \x03, because a bare \x03
            // followed by a digit in the text would be read as a colour.
            textValue += '\x0f' + openCodes(parent);
          } else {
            // Formats are toggles, so emitting them again switches them off.
            if (st.bold && !parent.bold) textValue += '\x02';
            if (st.italic && !parent.italic) textValue += '\x1d';
            if (st.underline && !parent.underline) textValue += '\x1f';
            if (st.strikethrough && !parent.strikethrough) textValue += '\x1e';
          }
        }
      }, {
        decodeEntities: true
      });
      parser.write(source);
      parser.end();

      // Persistent modes: wrap every line in the matching IRC codes.
      // Lines starting with "/" are left alone so commands keep working.
      var p = this.persistent;
      var prefix = (p.bold ? '\x02' : '') + (p.italic ? '\x1d' : '') + (p.underline ? '\x1f' : '') + (p.strikethrough ? '\x1e' : '');
      if (prefix) {
        var _context1;
        textValue = (0, _map.default)(_context1 = textValue.split('\n')).call(_context1, function (line) {
          if (!line || line.indexOf('/') === 0) {
            return line;
          }
          return prefix + line + prefix;
        }).join('\n');
      }
      return (0, _filter.default)(_context10 = textValue.split(/\r?\n/)).call(_context10, function (line) {
        return !!Misc.stripStyles(line);
      }).join('\n');
    },
    reset: function reset(rawHtml, shouldFocus) {
      this.$refs.editor.innerHTML = rawHtml || '';

      // NOTE: persistent formats are intentionally NOT cleared here, so the
      // next message keeps the same formatting until the user turns it off.
      this.applyPersistentVisuals();
      this.current_el_pos = 0;
      this.current_el = this.$refs.editor;
      var br = this.$refs.editor.querySelector('br');
      if (br) {
        br.parentNode.removeChild(br);
      }
      if (shouldFocus) {
        this.focus();
        this.reapplyDefaultColours();
        this.updateValueProps();
      } else {
        this.maybeEmitInput();
      }
    },
    resetStyles: function resetStyles() {
      this.focus();
      document.execCommand('styleWithCSS', false, true);
      document.execCommand('selectAll', false, null);
      document.execCommand('removeFormat', false, null);
      this.default_colour = null;
      this.default_bgcolour = null;

      // Explicit reset: clear all persistent modes
      this.persistent = {
        bold: false,
        italic: false,
        underline: false,
        strikethrough: false
      };
      this.applyPersistentVisuals();
    },
    /**
     * Re-apply the remembered foreground / background to an empty editor, so
     * the colours carry over to the next message.
     */
    reapplyDefaultColours: function reapplyDefaultColours() {
      if (this.default_colour) {
        this.setColour(this.default_colour.code, this.default_colour.colour);
      }
      if (this.default_bgcolour) {
        this.setBgColour(this.default_bgcolour.code, this.default_bgcolour.colour);
      }
    },
    /**
     * Is there a selection inside the editor? If not, put the caret back where
     * we last saw it. If there is, leave it alone so the colour applies to the
     * selected text instead of collapsing it.
     */
    ensureSelectionInEditor: function ensureSelectionInEditor() {
      var sel = window.getSelection();
      var inEditor = sel.rangeCount > 0 && this.$refs.editor.contains(sel.anchorNode);
      if (!inEditor) {
        this.focus();
      }
      return inEditor && !sel.isCollapsed;
    },
    setColour: function setColour(rawCode, colour) {
      var _context11;
      var code = (0, _padStart.default)(_context11 = String(rawCode)).call(_context11, 2, '0');
      var hasSelection = this.ensureSelectionInEditor();
      if (!hasSelection) {
        this.default_colour = {
          code: code,
          colour: colour
        };
      }
      document.execCommand('styleWithCSS', false, true);
      document.execCommand('foreColor', false, colour);
      var hex = this.normaliseColour(colour);
      if (hex) {
        this.code_map[hex] = code;
      }
      this.updateValueProps();
    },
    setBgColour: function setBgColour(rawCode, colour) {
      var _context12;
      var code = (0, _padStart.default)(_context12 = String(rawCode)).call(_context12, 2, '0');
      var hasSelection = this.ensureSelectionInEditor();
      if (!hasSelection) {
        this.default_bgcolour = {
          code: code,
          colour: colour
        };
      }
      document.execCommand('styleWithCSS', false, true);
      // hiliteColor is the standard one; backColor is the fallback for
      // browsers that don't support hiliteColor.
      if (!document.execCommand('hiliteColor', false, colour)) {
        document.execCommand('backColor', false, colour);
      }
      var hex = this.normaliseColour(colour);
      if (hex) {
        this.code_map[hex] = code;
      }
      this.updateValueProps();
    },
    /**
     * Turn off the foreground ('fg') or background ('bg') colour.
     */
    clearColour: function clearColour(which) {
      this.ensureSelectionInEditor();
      document.execCommand('styleWithCSS', false, true);
      if (which === 'fg') {
        this.default_colour = null;
        // There is no "unset" for foreColor, so use the editor's own text colour.
        // It isn't an IRC colour we applied, so buildIrcText ignores it.
        document.execCommand('foreColor', false, window.getComputedStyle(this.$refs.editor).color);
      } else {
        this.default_bgcolour = null;
        document.execCommand('hiliteColor', false, 'transparent');
      }
      this.updateValueProps();
    },
    /**
     * Show the persistent modes visually in the editor. They are applied to
     * the editor element itself, so they survive innerHTML being wiped.
     */
    applyPersistentVisuals: function applyPersistentVisuals() {
      var _context13;
      var editor = this.$refs.editor;
      if (!editor) {
        return;
      }
      var p = this.persistent;
      editor.style.fontWeight = p.bold ? 'bold' : '';
      editor.style.fontStyle = p.italic ? 'italic' : '';
      editor.style.textDecoration = (0, _filter.default)(_context13 = [p.underline && 'underline', p.strikethrough && 'line-through']).call(_context13, Boolean).join(' ');
    },
    /**
     * With text selected: style only the selection.
     * With no selection: toggle a persistent mode that applies to everything
     * typed (and every message sent) until toggled off.
     */
    toggleStyle: function toggleStyle(kind) {
      var editor = this.$refs.editor;
      var sel = window.getSelection();
      var hasSelection = sel && sel.rangeCount > 0 && !sel.isCollapsed && editor.contains(sel.anchorNode);
      if (hasSelection) {
        document.execCommand('styleWithCSS', false, true);
        if (kind === 'strikethrough') {
          var range = sel.getRangeAt(0);
          var span = document.createElement('span');
          span.style.textDecoration = 'line-through';
          span.appendChild(range.extractContents());
          range.insertNode(span);
          range.setStartAfter(span);
          range.setEndAfter(span);
          sel.removeAllRanges();
          sel.addRange(range);
        } else {
          document.execCommand(kind, false, null);
        }
      } else {
        this.persistent[kind] = !this.persistent[kind];
        this.applyPersistentVisuals();
      }
      this.updateValueProps();
    },
    toggleBold: function toggleBold() {
      this.toggleStyle('bold');
    },
    toggleItalic: function toggleItalic() {
      this.toggleStyle('italic');
    },
    toggleUnderline: function toggleUnderline() {
      this.toggleStyle('underline');
    },
    toggleStrikethrough: function toggleStrikethrough() {
      this.toggleStyle('strikethrough');
    },
    addImg: function addImg(alt, url, props) {
      this.focus();
      var existingImages = (0, _toConsumableArray2.default)((0, _values.default)(_lodash.default).call(_lodash.default, this.$refs.editor.querySelectorAll('img')));
      document.execCommand('styleWithCSS', false, true);
      document.execCommand('insertImage', false, url);
      var newImg = null;
      var images = (0, _toConsumableArray2.default)((0, _values.default)(_lodash.default).call(_lodash.default, this.$refs.editor.querySelectorAll('img')));
      images.forEach(function (img) {
        if (existingImages.indexOf(img) === -1) {
          newImg = img;
        }
      });
      newImg.alt = alt;
      (0, _assign.default)(newImg, props);
      var prevElCnt = 0;
      var el = newImg;
      while (el) {
        el = el.previousSibling;
        prevElCnt++;
      }
      this.current_el = this.$refs.editor;
      this.current_el_pos = prevElCnt;
      this.updateValueProps();
      this.focus();
    },
    insertText: function insertText(text) {
      this.focus();
      document.execCommand('insertText', false, text);
      this.updateValueProps();
      this.focus();
    },
    setCurrentWord: function setCurrentWord(text, keepPosition, toPosition) {
      var el = this.current_el;
      var pos = this.current_el_pos;
      var val = el.textContent || '';
      var startVal = val.substr(0, pos);
      var space = startVal.replace(/\xA0/g, ' ').lastIndexOf(' ');
      if (space === -1) {
        space = 0;
      } else {
        space++;
      }
      var startPos = space;
      var endVal = val.substr(pos);
      space = endVal.replace(/\xA0/g, ' ').indexOf(' ');
      if (space === -1) space = endVal.length;
      var endPos = toPosition ? 0 : space;
      el.textContent = startVal.substr(0, startPos) + text + endVal.substr(endPos);
      var range = document.createRange();
      if (keepPosition) {
        range.setStart(el, pos);
        range.setEnd(el, pos);
      } else if (el.nodeType === 3) {
        range.setStart(el, startPos + text.length);
        range.setEnd(el, startPos + text.length);
      } else {
        range.setStart(el, 1);
        range.setEnd(el, 1);
      }
      this.$refs.editor.focus();
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
      this.updateValueProps();
    },
    getCurrentWord: function getCurrentWord(toPosition) {
      var el = this.current_el;
      var pos = this.current_el_pos;
      var val = el.textContent;
      var cleanVal = val.replace(/\xA0/g, ' ');
      var startVal = cleanVal.substr(0, pos);
      var space = startVal.lastIndexOf(' ');
      if (space === -1) {
        space = 0;
      } else {
        space++;
      }
      var startPos = space;
      space = cleanVal.indexOf(' ', startPos);
      if (space === -1) {
        space = val.length;
      }
      var endPos = toPosition ? pos - startPos : space;
      return {
        word: val.substr(startPos, endPos),
        position: pos - startPos
      };
    },
    getCaretIdx: function getCaretIdx() {
      var position = 0;
      var selection = window.getSelection();
      if (selection.rangeCount !== 0) {
        var range = window.getSelection().getRangeAt(0);
        var caretRange = range.cloneRange();
        caretRange.selectNodeContents(this.$el);
        caretRange.setEnd(range.endContainer, range.endOffset);
        position = caretRange.toString().length;
      }
      return position;
    },
    getRawText: function getRawText() {
      return this.$refs.editor.innerText;
    },
    focus: function focus() {
      var selection = window.getSelection();
      var range = document.createRange();
      range.setStart(this.current_el || this.$refs.editor, this.current_el_pos || 0);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }
});
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["utils"]) window._kiwi_exports["components"]["utils"] = {};
window._kiwi_exports["components"]["utils"]["IrcInput"]
window._kiwi_exports.components.utils.IrcInput = exports.default ? exports.default : exports;
